<template>
  <!-- Declaracion del pie de pagina -->
  <v-footer
    id="core-footer"
    height="60"
    absolute
    color="transparent"
  >
  <!-- Declaracion de los items del pie de pagina -->
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <!-- Declaracion del copyright y del boton flotante -->
    <span class="font-weight-light copyright" style="padding-right: 1rem">
      <span
        @click.stop="registrarClickEasterEgg"
        @mousedown.stop="iniciarPresionEasterEgg"
        @mouseup.stop="terminarPresionEasterEgg"
        @mouseleave.stop="terminarPresionEasterEgg"
        @touchstart.stop="iniciarPresionEasterEgg"
        @touchend.stop="terminarPresionEasterEgg"
        @touchcancel.stop="terminarPresionEasterEgg"
      >
        &copy;
      </span>
      {{ (new Date()).getFullYear() }}
      <a
        class="text-decoration-none green--text"
        href="http://www.managrx.com/"
        target="_blank">ManagrX</a>
    </span>
    <!-- Mandamos a llamar al modulo que contiene el diseño del chat flotante desplegable  -->
    <floatChat />
    <ControlMaestroDialog ref="controlMaestroDialog" />
  </v-footer>
</template>

<script>
 //Importamos el modulo que vayamos a utilizar para el pie de pagina  -->
import floatChat from "./FloatChat.vue";
import ControlMaestroDialog from "../DashViews/ControlMaestroDialog.vue";
export default {
  data: () => ({
    links: [
      // { name: 'Home', Link: '/dashboard/reportes' },
    ],
    easterEggClicks: 0,
    easterEggTimer: null,
    easterEggHoldTimer: null,
    ignoreNextClick: false,
  }),
  components:{
    ControlMaestroDialog,
    floatChat, //Se agrega el modulo importado para poder hacer uso de el
    // Chat
  },
  methods: {
    resetEasterEgg() {
      this.easterEggClicks = 0;
      this.ignoreNextClick = false;  

      if (this.easterEggTimer) {
        clearTimeout(this.easterEggTimer);
        this.easterEggTimer = null;
      }

      if (this.easterEggHoldTimer) {
        clearTimeout(this.easterEggHoldTimer);
        this.easterEggHoldTimer = null;
      }
    },

    abrirControlMaestro() {
      if (
        this.$refs.controlMaestroDialog &&
        typeof this.$refs.controlMaestroDialog.openDialog === "function"
      ) {
        this.$refs.controlMaestroDialog.openDialog();
      }
    },

    registrarClickEasterEgg() {
      if (this.ignoreNextClick) {
        this.ignoreNextClick = false;
        return;
      }

      if (this.easterEggClicks >= 3) {
        return;
      }

      this.easterEggClicks += 1;

      if (this.easterEggTimer) {
        clearTimeout(this.easterEggTimer);
      }

      this.easterEggTimer = setTimeout(() => {
        this.resetEasterEgg();
      }, 1500);
    },

    iniciarPresionEasterEgg() {
      if (this.easterEggClicks !== 3) {
        return;
      }

      if (this.easterEggHoldTimer) {
        clearTimeout(this.easterEggHoldTimer);
      }

      this.easterEggHoldTimer = setTimeout(() => {
        this.ignoreNextClick = true;
        this.abrirControlMaestro();

        this.easterEggClicks = 0;

        if (this.easterEggTimer) {
          clearTimeout(this.easterEggTimer);
          this.easterEggTimer = null;
        }

        if (this.easterEggHoldTimer) {
          clearTimeout(this.easterEggHoldTimer);
          this.easterEggHoldTimer = null;
        }
      }, 1000);
    },

    terminarPresionEasterEgg() {
      if (this.easterEggHoldTimer) {
        clearTimeout(this.easterEggHoldTimer);
        this.easterEggHoldTimer = null;
      }
    },
  },
  beforeDestroy() {
    this.resetEasterEgg();
  },
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
